/**
 * Hebrew customer copy for public package confirmation + access.
 *
 * EMAIL TEMPLATES (server-side only — browser has no SMTP)
 * --------------------------------------------------------
 * A. Confirmation (card paid) — sent by existing LDS/HYP post-payment mailers:
 *    Subject: אישור הזמנה | HR-########
 *    Body: ההזמנה התקבלה ומטופלת. מספר הזמנה HR-… אישור נשלח למייל זה.
 *
 * B. Bank-transfer instructions — existing
 *    POST /lds_orders/:id/ensure-bank-transfer-confirmation
 *    Subject: אישור הזמנה – ממתין להעברה בנקאית | HR-########
 *    Include amount, domestic/international details, remark: ציינו HR-… בהערות.
 *
 * C. Access code — POST /api/public/booking-access/request-code
 *    Body: { orderNumber, lastName, email } — OTP is sent to the submitted email
 *    Subject: קוד כניסה להזמנה | HotelsRiver
 *    Body: קוד הכניסה להזמנה שלכם הוא: ######  (תוקף 12 דקות)
 */

export const PUBLIC_BOOKING_COPY = Object.freeze({
  cardPaidTitle: "ההזמנה התקבלה",
  cardPaidLead: "קיבלנו את ההזמנה שלכם והיא נמצאת בטיפול.",
  cardPaidEmail: "אישור ההזמנה נשלח אליכם למייל.",
  bankPendingTitle: "ממתין להעברה בנקאית",
  bankPendingLead: "ההזמנה נפתחה וממתינה להשלמת תשלום",
  bankPaidTitle: "התשלום התקבל",
  bankPaidLead: "זיהינו את ההעברה. ההזמנה נמצאת בטיפול.",
  processingTitle: "התשלום התקבל",
  processingLead: "התשלום נקלט. אישור ההזמנה מול הספק עדיין בטיפול.",
  partialTitle: "התשלום התקבל חלקית",
  partialLead: "נקלט תשלום, ונותרה יתרה להשלמה.",
  fallbackTitle: "ההזמנה התקבלה",
  fallbackLead: "קיבלנו את ההזמנה שלכם והיא נמצאת בטיפול.",
  awaitingTitle: "ההזמנה התקבלה",
  awaitingLead: "קיבלנו את ההזמנה שלכם. סטטוס התשלום מתעדכן לפי הרישום במערכת.",
  paidAmountLabel: "שולם",
  remainingAmountLabel: "יתרה",
  saveNumberNote: "שמרו את מספר ההזמנה לצפייה עתידית בהזמנה",
  copyNumber: "העתקת מספר ההזמנה",
  copiedNumber: "מספר ההזמנה הועתק",
  copyFailed: "לא ניתן להעתיק כרגע. העתיקו ידנית.",
  nextStepsTitle: "מה קורה עכשיו?",
  summaryTitle: "סיכום ההזמנה",
  travelersTitle: "נוסעים",
  flightsTitle: "טיסות",
  outbound: "הלוך",
  inbound: "חזור",
  hotelTitle: "מלון וחדרים",
  baggageTitle: "כבודה ותוספות",
  baggageNone: "לא נבחרה כבודה נוספת",
  paymentTitle: "תשלום",
  paidStatus: "שולם",
  pendingStatus: "ממתין לתשלום",
  receivedStatus: "התשלום התקבל",
  partialStatus: "יתרה לתשלום",
  methodCard: "כרטיס אשראי",
  methodBank: "העברה בנקאית",
  totalLabel: "סה״כ לתשלום",
  paidTotalLabel: "סה״כ שולם",
  amountDue: "סכום להעברה",
  bankDetailsTitle: "פרטי העברה בנקאית",
  bankRemarkPrefix: "הקפידו לציין בהערות להעברה:",
  bankEmailedNote: "פרטי ההעברה נשלחים גם למייל שציינתם בהזמנה.",
  laterAccessTitle: "כניסה להזמנה בהמשך",
  laterAccessLead: "לצפייה מאוחרת תצטרכו את מספר ההזמנה, שם המשפחה, המייל, וקוד חד־פעמי שיישלח לתיבה.",
  viewBooking: "צפייה בהזמנה",
  enterBooking: "כניסה להזמנה",
  logoutPersonalArea: "יציאה מהאזור האישי",
  logoutBusy: "יוצאים…",
  supportTitle: "צריכים עזרה?",
  supportLead: "אנחנו כאן בצ׳אט או במייל.",
  chatCta: "צ׳אט",
  emailCta: "מייל",
  supportEmail: "support@hotelsriver.com",
  accessPageTitle: "כניסה להזמנה",
  accessLead: "הזינו מספר הזמנה, שם משפחה ומייל. נשלח קוד כניסה חד־פעמי לכתובת שהזנתם.",
  accessCodeLead: "הזינו את הקוד שנשלח למייל כדי להיכנס לפרטי ההזמנה.",
  accessBrandSub: "צפייה בהזמנה קיימת",
  accessHint: "הקוד החד־פעמי יישלח למייל שתזינו כאן.",
  orderNumberLabel: "מספר הזמנה",
  lastNameLabel: "שם משפחה",
  emailLabel: "מייל",
  loginCta: "התחברות",
  sendCode: "שלחו לי קוד למייל",
  sendingCode: "מתחברים…",
  codeSent: "שלחנו קוד כניסה למייל שהזנתם",
  codeLabel: "קוד כניסה",
  verifyCta: "אימות וכניסה",
  verifying: "מאמתים…",
  resendCode: "שלחו קוד חדש",
  accessGenericError: "לא ניתן להשלים את הכניסה כרגע. וודאו את הפרטים ונסו שוב מאוחר יותר.",
  codeGenericError: "הקוד שגוי או שפג תוקפו. נסו שוב.",
  noFakeSend: "לא ניתן לשלוח קוד כרגע. נסו שוב בעוד רגע.",
  gateTitle: "כניסה להזמנה",
  gateLead: "כדי לראות את פרטי ההזמנה יש לאמת כניסה עם מספר הזמנה, שם משפחה, מייל וקוד לתיבה.",
  nightsLabel: (n) => (n === 1 ? "לילה אחד" : `${n} לילות`),
  travelersLabel: (n) => (n === 1 ? "נוסע אחד" : `${n} נוסעים`),
  roomsLabel: (n) => (n === 1 ? "חדר אחד" : `${n} חדרים`),
});

export const CARD_NEXT_STEPS = Object.freeze([
  {
    id: "received",
    title: "ההזמנה התקבלה",
    detail: "קיבלנו את ההזמנה והיא נמצאת בטיפול.",
  },
  {
    id: "email",
    title: "אישור במייל",
    detail: "אישור ההזמנה נשלח אליכם למייל.",
  },
  {
    id: "supplier",
    title: "אישור מול הספק",
    detail: "צוות הנסיעות מאשר את המלון והטיסות.",
  },
  {
    id: "voucher",
    title: "שובר נסיעה",
    detail: "השובר יישלח כשההזמנה תאושר סופית.",
  },
]);

export const BANK_PENDING_NEXT_STEPS = Object.freeze([
  {
    id: "opened",
    title: "ההזמנה נפתחה",
    detail: "ההזמנה ממתינה להשלמת תשלום בהעברה בנקאית.",
  },
  {
    id: "transfer",
    title: "בצעו העברה",
    detail: "העבירו את הסכום וציינו את מספר ההזמנה בהערות.",
  },
  {
    id: "detect",
    title: "זיהוי תשלום",
    detail: "לאחר זיהוי התשלום הסטטוס יתעדכן אוטומטית.",
  },
  {
    id: "final",
    title: "אישור סופי",
    detail: "אישור יישלח למייל אחרי קליטת התשלום.",
  },
]);

export const BANK_PAID_NEXT_STEPS = Object.freeze([
  {
    id: "received",
    title: "התשלום התקבל",
    detail: "זיהינו את ההעברה הבנקאית.",
  },
  {
    id: "handling",
    title: "ההזמנה בטיפול",
    detail: "צוות הנסיעות ממשיך באישור מול הספק.",
  },
  {
    id: "email",
    title: "אישור במייל",
    detail: "אישור סופי יישלח למייל.",
  },
]);

export const PROCESSING_NEXT_STEPS = Object.freeze([
  {
    id: "paid",
    title: "התשלום התקבל",
    detail: "התשלום נקלט במערכת.",
  },
  {
    id: "supplier",
    title: "אישור הזמנה בטיפול",
    detail: "אישור מול הספק עדיין בתהליך.",
  },
  {
    id: "email",
    title: "עדכון במייל",
    detail: "נעדכן אתכם למייל כשההזמנה תאושר.",
  },
]);
